import { gql } from 'graphql-request';

export const LOGIN = gql`
  mutation passwordLogin($username: String!, $password: String!, $otp: String) {
    passwordLogin(
      input: { username: $username, password: $password, otp: $otp }
    ) {
      success
      token {
        accessToken
        refreshToken
      }
      mfaConfigured
      qrCode
    }
  }
`;

export const GENERATE_OTP = gql`
  mutation generateOtp($phone: String!, $roles: [Roles]) {
    generateOtp(input: { phone: $phone, roles: $roles })
  }
`;

export const VALIDATE_OTP = gql`
  mutation loginWithOtp(
    $phone: String!
    $otp: String!
    $skipOnboarding: Boolean
  ) {
    otpLogin(
      input: { username: $phone, otp: $otp, skipOnboarding: $skipOnboarding }
    ) {
      refreshToken
      accessToken
    }
  }
`;

export const REFRESH = gql`
  mutation refresh($refreshToken: String!) {
    refresh(input: { refreshToken: $refreshToken }) {
      accessToken
      refreshToken
    }
  }
`;

export const GET_PROFILE = gql`
  query getProfile {
    getProfile {
      id
      email
      firstName
      lastName
    }
  }
`;

export const LOGOUT = gql`
  mutation logout($refreshToken: String!) {
    logout(input: { refreshToken: $refreshToken })
  }
`;

export const GET_PRESIGNED_URL = gql`
  query getPresignedUrl(
    $category: FileCategory!
    $urlType: UrlType
    $key: String
  ) {
    getPresignedUrl(
      input: { category: $category, urlType: $urlType, key: $key }
    ) {
      url
      fileName
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($input: ResetPasswordInput) {
    resetPassword(input: $input)
  }
`;
